import React from 'react';
import { FaTh, FaList } from 'react-icons/fa';

export default function ViewToggle({ mode, setMode, hideOnMobile = true }) {
  return (
    <div
      className={`view-toggle ${hideOnMobile ? 'hide-on-mobile' : ''}`}
      role="group"
      aria-label="Alternar visualização"
      style={{
        display: 'inline-flex',
        background: '#fff',
        border: '1px solid #e5e7eb',
        borderRadius: 10,
        padding: 3,
        gap: 2,
      }}
    >
      <button
        type="button"
        onClick={() => setMode('cards')}
        title="Cards"
        aria-pressed={mode === 'cards'}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '6px 12px', borderRadius: 7, fontSize: 12, fontWeight: 600,
          border: 'none', cursor: 'pointer',
          background: mode === 'cards' ? '#C4786E' : 'transparent',
          color: mode === 'cards' ? '#fff' : '#6b7280',
          transition: 'background 150ms ease, color 150ms ease',
        }}
      >
        <FaTh size={12} /> Cards
      </button>
      <button
        type="button"
        onClick={() => setMode('tabela')}
        title="Tabela"
        aria-pressed={mode === 'tabela'}
        style={{
          display: 'inline-flex', alignItems: 'center', gap: 6,
          padding: '6px 12px', borderRadius: 7, fontSize: 12, fontWeight: 600,
          border: 'none', cursor: 'pointer',
          background: mode === 'tabela' ? '#C4786E' : 'transparent',
          color: mode === 'tabela' ? '#fff' : '#6b7280',
          transition: 'background 150ms ease, color 150ms ease',
        }}
      >
        <FaList size={12} /> Tabela
      </button>
    </div>
  );
}
